import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Business } from '../models/business.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EditOverviewComponent } from '../edit-overview/edit-overview.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';

@Component({
  selector: 'app-edit-desc',
  templateUrl: './edit-desc.component.html',
  styleUrls: ['./edit-desc.component.scss']
})
export class EditDescComponent implements OnInit {

  formGroup: FormGroup;
  business: Business;
  charRemainingCnt: number;
  _originDesc: string;
  _MAX_CHARACTERS = 2000;
  isBusy = false;
  constructor(private _matDialogRef: MatDialogRef<EditOverviewComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private businessManagerService: BusinessManagerService) {
    this.business = data.business;
    this.charRemainingCnt = this.business.description ?
      this._MAX_CHARACTERS - this.business.description.length : this._MAX_CHARACTERS;
    this._originDesc = this.business.description;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this._matDialogRef.close(null);
    });

    this.formGroup = new FormGroup({
      description: new FormControl('', [Validators.maxLength(this._MAX_CHARACTERS)])
    });
  }

  cancel () {
    this.business.description = this._originDesc;
    this._matDialogRef.close(null);
  }

  textAreaChanged () {
    this.charRemainingCnt = this.business.description.length <= this._MAX_CHARACTERS ?
      this._MAX_CHARACTERS - this.business.description.length : 0;
  }

  async save () {
    if (this.business.description) {
      this.business.description = this.business.description.trim();
    }
    try {
      this.isBusy = true;
      await this.businessManagerService.updateBusiness(this.business);
      this.isBusy = false;
      this._matDialogRef.close(true);
    } catch (e) {
      this.isBusy = false;
      this._matDialogRef.close(false);
    }
  }
}

